<div *ngIf="showPendingPhonesNotification && !showFailedPhonesNotification && isPhonePlanSupported" class="notice-banner-container mt-4">
  <div class="container">
    <div class="notice-banner d-flex flex-md-row flex-column">
      <div class="banner-text">
        <div class="d-flex flex-row">
          <mat-icon style="color:#E18801 !important;" svgIcon="error-warning"></mat-icon>
          <div>
            <div class="banner-text-container"><span>{{bannerText}}</span></div>
            <div class="banner-subtext-container"><span>{{bannerSubText}}</span></div>
          </div>
        </div>
      </div>
      <div class="banner-icon " style="font-size:16px;font-weight:400;">
        <button (click)="viewMyDevices();" style="text-decoration: underline;font-weight: 400;" class="link">{{textOnLink}}</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showFailedPhonesNotification && isPhonePlanSupported" class="notice-banner-failure-container mt-4">
  <div class="container">
    <div class="notice-banner d-flex flex-md-row flex-column failure">
      <div class="banner-text">
        <div class="d-flex flex-row">
          <mat-icon style="color:#B90000 !important;" svgIcon="error-warning"></mat-icon>
          <div>
            <div class="banner-text-container"><span>{{bannerText}}</span></div>
            <div class="banner-subtext-container"><span>{{bannerSubText}}</span></div>
          </div>
        </div>
      </div>
      <div class="banner-icon " style="font-size:16px;font-weight:400;">
        <button (click)="viewMyDevices();" style="text-decoration: underline;font-weight: 400;" class="link">{{textOnLink}}</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isSuspended" class="notice-banner-container mt-4">
  <div class="container">
    <div class="notice-banner d-flex flex-md-row flex-column">
      <div class="banner-text">
        <div class="d-flex flex-row">
          <mat-icon style="color:#E18801 !important;" svgIcon="error-warning"></mat-icon>
          <div>
            <div class="banner-subtext-container"><span>{{bannerText}}</span></div>
            <div class="banner-text-container"><span>{{bannerSubText}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
